<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ primeiroNome(userData.name) }}
        </p>
        <span class="user-status">{{ corrigirFuncaoUsuario(userData.authority) }}</span>
      </div>
      <b-avatar
        size="40"
        :src="userData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!userData.name"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>

    <b-dropdown-item
      :to="{ name: 'conta-configuracoes' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span>Configurações</span>
    </b-dropdown-item>

    <b-dropdown-item
      @click="openWhatsApp"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="MessageCircleIcon" class="mr-50" />
      <span>Fale com a gente</span>
    </b-dropdown-item>

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>Sair</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
  BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BButton
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
import { avatarText } from '@core/utils/filter'
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { TheMask } from "vue-the-mask";
import { primeiroNome, corrigirFuncaoUsuario } from '@core/utils/funcoes'

export default {
  components: {
    BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
    BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BButton,
    ValidationProvider, ValidationObserver, TheMask,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('usuarioData')),
      avatarText,
    }
  },
  methods: {

    primeiroNome,
    corrigirFuncaoUsuario,

    logout() {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem('usuarioData')
      this.$ability.update(initialAbility)
      this.$router.push({ name: 'auth-login' })
    },
    openWhatsApp () {
      const usuarioData = JSON.parse(localStorage.getItem('usuarioData'));
      const msg = `Olá! Me chamo ${usuarioData.name} (${usuarioData.email}) e estou precisando de uma ajudinha.`; 
      window.open(`https://wa.me/558592401035/?text=${msg}`, '_blank');
    },
  },
}
</script>
